export default {
  deleteTitle: 'Student Fee',
  overviewTitle: 'Student Fee',
  overviewRouterUrl: 'studentfees',
  getFilterName (context) { return 'studentfees' },
  overviewApiUrl: '/studentfees/',
  detailTitle: 'Student Fee Detail',
  detailRouterUrl: 'studentfee',
  detailApiUrl: '/studentfees/',
  quickFilterName: 'Intake',
  quickFilterField: 'name',
  advancedSearch: true,
  updateNewRecord (context, rec) {
    rec.registration_fee_amount = 0.0
    rec.participationfee1_amount = 0.0
    rec.participationfee2_amount = 0.0
    rec.administrationfee1_amount = 0.0
    rec.administrationfee2_amount = 0.0
    rec.monthly_allowance_amount = 0.0
  },
  getDefaultFilter (context) { return {} },
  sortOrder: [
    {
      field: 'intake',
      sortField: 'intake',
      direction: 'asc'
    }
  ],
  fields:
  [
    {title: 'Intake', name: 'intake', sortField: 'intake', link: '#/studentfee/{id}'},
    {title: 'Scholarship', name: 'scholarship_code', sortField: 'scholarship_code'},
    {title: 'Reg Fee', name: 'registration_fee_amount', sortField: 'registration_fee_amount'},
    {title: 'Part Fee Y1', name: 'participationfee1_amount', sortField: 'participationfee1_amount'},
    {title: 'Part Fee Y2', name: 'participationfee2_amount', sortField: 'participationfee2_amount'},
    {title: 'Admin Fee Y1', name: 'administrationfee1_amount', sortField: 'administrationfee1_amount'},
    {title: 'Admin Fee Y2', name: 'administrationfee2_amount', sortField: 'administrationfee2_amount'},
    {title: 'Monthly Allowance', name: 'monthly_allowance_amount', sortField: 'monthly_allowance_amount'},
    {title: 'Last Edit', name: 'edit_timestamp', sortField: 'edit_timestamp', callback: 'formatTimeStamp'},
    {name: '__slot:actions', title: '', titleClass: 'text-center', dataClass: 'text-center'}
  ]
}



// WEBPACK FOOTER //
// ./src/views/StudentFee/FieldDefs.js